import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import { IKioskConfigGridData } from './model/kioskConfig_grid_data';
import { KioskGridParams } from './model/kiosk_grid_params';
import { KioskConfiguration } from './model/kiosk-configuration';
import { map } from 'rxjs/operators';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';

@Injectable({
  providedIn: 'root'
})
export class KioskConfigurationService {
  private kioskConfigUri = '';
  private appConfig!: AppConfigurations;

  constructor(private http: HttpClient, private appInitService: AppInitService) {
    this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }
  
  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.kioskConfigUri =
    `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.kioskConfigurationController}`;
  }
private getKioskQueryParams(kioskGridParams: KioskGridParams): string {
  const skip = (kioskGridParams.pageInfo.Page - 1) * kioskGridParams.pageInfo.PageSize;
  return `?SearchText=${kioskGridParams.searchText}&PageInfo.Page=${kioskGridParams.pageInfo.Page}&PageInfo.PageSize=${kioskGridParams.pageInfo.PageSize}
  &Pageinfo.Skip=${skip}&SortInfo.SortColumn=${kioskGridParams.sortInfo.SortColumn}&SortInfo.SortDirection=${kioskGridParams.sortInfo.sortDirection}`;
}

getKioskConfigurations(kioskGridParams: KioskGridParams): Observable<IKioskConfigGridData[]>  {
  const queryParamsForGrid = this.getKioskQueryParams(kioskGridParams);
  return this.http.get<IKioskConfigGridData[]>(`${this.kioskConfigUri}${queryParamsForGrid}`);
 }

getKioskConfiguration(locationCode: string): Observable<KioskConfiguration> {
  let queryParams = new HttpParams();
  queryParams = queryParams.set("locationCode", locationCode)

  return this.http.get<KioskConfiguration>(`${this.kioskConfigUri}/locationConfig`,{params : queryParams});

}

updateKioskConfiguration(kioskConfiguration: KioskConfiguration): Observable<KioskConfiguration> {
  return this.http.put(`${this.kioskConfigUri}/${kioskConfiguration.locationId}`, kioskConfiguration ).pipe(
    map(() => kioskConfiguration)
  );
}

addKioskConfiguration(kioskConfiguration: KioskConfiguration): Observable<KioskConfiguration> {
  return this.http.post(`${this.kioskConfigUri}`, kioskConfiguration).pipe(
    map(() => kioskConfiguration)
  );
}

deleteKioskConfiguration(locationId: number): Observable<{}> {
  return this.http.delete(`${this.kioskConfigUri}/${locationId}`);
}

copyKioskConfigurations(copyFrom: number, copyTo: number[]): Observable<{}> {
  const kioskConfigurationCopyModel = { copyFromLocationId : copyFrom, copyToLocationIds : copyTo};
  return this.http.post(`${this.kioskConfigUri}/copyKioskConFiguration`, kioskConfigurationCopyModel);
}
}
